import React from "react";
import styled from "styled-components";
import CharacterSingleNav from "components/common/character/CharacterSingleNav/CharacterSingleNav";
import { CharacterResult } from "common/character/dto/CharacterResult";
import { DivMarginTop } from "components/common/style/margin/DivMarginTop";
import CharacterRelateContainNav from "components/common/character/CharacterRelateContain/CharacterRelateContainNav";
import { useLocalStorageValue } from "hooks/hook_util/local_storage/useLocalStorageEntry";
import CharacterRelateContainEditNav from "components/common/character/CharacterRelateContain/CharacterRelateContainEditNav";
import { CHARACTER_EDIT_RELATE } from "constant/character/character.constant";

type CharacterReadProps = {
  character: CharacterResult;
};

const CharacterRead = ({ character }: CharacterReadProps) => {
  const relateEdit = useLocalStorageValue(CHARACTER_EDIT_RELATE.RELATE_EDIT);
  const relateNav = useLocalStorageValue(CHARACTER_EDIT_RELATE.RELATE_NAV);

  return (
    <div>
      <div>{character.letter}</div>
      <DivNav>
        <CharacterSingleNav character={character} hideReadNav={true} />
        {relateNav && (
          <DivMarginTop mt={1}>
            <CharacterRelateContainNav character={character} />
          </DivMarginTop>
        )}
        {relateEdit === "edit" && (
          <DivMarginTop mt={1}>
            <CharacterRelateContainEditNav
              characterId={character.id}
              contain={character.relate.contain ?? []}
            />
          </DivMarginTop>
        )}
      </DivNav>
    </div>
  );
};

const DivNav = styled.div`
  margin-top: 1.5rem;
`;

export default CharacterRead;
